module.exports = __webpack_public_path__ + "static/media/valor1.cf2d386d.png";